import { Component, OnInit } from "@angular/core";
import { SetupService } from "../setup.service";

@Component({
  selector: 'app-setup-complete',
  templateUrl: './setup-complete.component.html'
})
export class SetupCompleteComponent implements OnInit {
  constructor(private setupService: SetupService) { }
  ngOnInit(): void {
    this.setupService.isSetupCompleted$.next();
  }

}